interface MatchableEntry {
  id: string;
  propertyId: string;
  carId?: string | null;
  content: string;
  supersededById?: string | null;
}

const STOPWORDS = new Set([
  'elevator',
  'schindler',
  'should',
  'would',
  'about',
  'their',
  'there',
  'which',
]);

function words(text: string): Set<string> {
  const found = text.toLowerCase().match(/[a-z0-9]{5,}/g) ?? [];
  return new Set(found.filter((w) => !STOPWORDS.has(w)));
}

export function findSupersedable<T extends MatchableEntry>(
  entries: T[],
  draft: { propertyId: string; carId?: string | null; content: string },
): T | undefined {
  const draftWords = words(draft.content);
  if (draftWords.size < 2) return undefined;
  return entries.find(
    (e) =>
      !e.supersededById &&
      e.propertyId === draft.propertyId &&
      (e.carId ?? null) === (draft.carId ?? null) &&
      [...words(e.content)].filter((w) => draftWords.has(w)).length >= 2,
  );
}
